<div style="display: flex; align-items: center; justify-content: flex-end">
  <!-- Input Search -->
  @if (search) {
    <form autocomplete="off" style="width: 100%">
      <mat-form-field class="no-hint form-field-primary">
        <mat-label>Buscar</mat-label>
        <input
          matInput
          type="text"
          #inputSearch
          [(ngModel)]="search.value"
          [ngModelOptions]="{ standalone: true }"
          class="input-search"
        />
        @if (search.value) {
          <button
            matSuffix
            mat-icon-button
            type="button"
            aria-label="Clear"
            (click)="search.value = ''; cambioFiltro()"
          >
            <mat-icon>close</mat-icon>
          </button>
        }
        <!-- <img
        *ngIf="!search.value"
        matSuffix
        src="assets/iconos/buscar.png"
        alt="buscar"
        style="width: 40px; margin-right: 0.5em; cursor: pointer"
        />
      <img
        *ngIf="search.value"
        matSuffix
        src="assets/iconos/cerrar.png"
        alt="cerrar"
        style="width: 40px; margin-right: 0.5em; cursor: pointer"
        (click)="search.value = ''; cambioFiltro()"
        /> -->
      </mat-form-field>
    </form>
  }

  @if (filtrosVisibles.length) {
    <div>
      <!-- Boton Filtro -->
      <!-- <div class="filter-cnt"> -->
      <button
        mat-button
        [matMenuTriggerFor]="filterMenu"
        [ngStyle]="{ color: filtroActivo ? 'red' : 'unset' }"
        class="boton-filtro fondo-85"
      >
        <div class="row-center">
          <mat-icon>filter_alt</mat-icon>
          <span class="text" style="margin-right: 0.5em">
            {{ (isHandset$ | async) ? '' : 'Filtro' }}
          </span>
          <!-- <img
        matSuffix
        src="assets/iconos/filtro.png"
        alt="filtro"
        style="width: 40px"
        /> -->
        </div>
      </button>
      <!-- Elementos Menu Filtro -->
      <mat-menu #filterMenu="matMenu">
        <div (click)="$event.stopPropagation()" style="padding: 1em">
          <p style="text-align: right; font-weight: 500">
            <span
              (click)="limpiarFiltros()"
              style="cursor: pointer"
              class="text"
            >
              Limpiar filtros
            </span>
          </p>
          <form autocomplete="off">
            @for (dato of filtros; track dato; let i = $index) {
              @if (!estaOcultoPorGlobal(dato)) {
              <!-- Select -->
              @if (dato.tipo === 'select') {
                <mat-form-field>
                  <mat-label>{{ dato.label }}</mat-label>
                  <mat-select
                    [name]="dato.label"
                    [(ngModel)]="dato.filter.value"
                    (selectionChange)="cambioFiltro()"
                  >
                    @for (elemento of dato.elementos; track elemento) {
                      <mat-option
                        class="text"
                        [value]="
                          dato.selectValue
                            ? elemento[dato.selectValue]
                            : elemento
                        "
                      >
                        {{
                          dato.selectLabel
                            ? elemento[dato.selectLabel]
                            : (elemento | nombreDivision)
                        }}
                      </mat-option>
                    }
                  </mat-select>
                  @if (dato.filter.value) {
                    <button
                      matSuffix
                      mat-icon-button
                      type="button"
                      aria-label="Clear"
                      (click)="
                        dato.filter.value = undefined;
                        $event.stopPropagation();
                        cambioFiltro()
                      "
                    >
                      <mat-icon>close</mat-icon>
                    </button>
                  }
                </mat-form-field>
              }
              <!-- Input -->
              @if (dato.tipo === 'input') {
                <mat-form-field>
                  <mat-label>{{ dato.label }}</mat-label>
                  <input
                    matInput
                    type="search"
                    [name]="dato.label"
                    [(ngModel)]="dato.filter.value"
                    (ngModelChange)="cambioFiltro()"
                  />
                </mat-form-field>
              }
              <!-- Input -->
              @if (dato.tipo === 'input-number') {
                <mat-form-field>
                  <mat-label>{{ dato.label }}</mat-label>
                  <input
                    matInput
                    type="number"
                    [name]="dato.label"
                    [(ngModel)]="dato.filter.value"
                    (ngModelChange)="cambioFiltro()"
                  />
                </mat-form-field>
              }
              <!-- Date Range -->
              @if (dato.tipo === 'dateRange') {
                <mat-form-field>
                  <mat-label>{{ dato.label }}</mat-label>
                  <mat-date-range-input [rangePicker]="picker">
                    <input
                      matStartDate
                      placeholder="Desde"
                      [name]="dato.label"
                      [(ngModel)]="dato.desde"
                      (ngModelChange)="cambioFiltro()"
                    />
                    <input
                      matEndDate
                      placeholder="Hasta"
                      [name]="dato.label"
                      [(ngModel)]="dato.hasta"
                      (ngModelChange)="cambioFiltro()"
                    />
                  </mat-date-range-input>
                  <mat-datepicker-toggle
                    matSuffix
                    [for]="picker"
                  ></mat-datepicker-toggle>
                  <mat-date-range-picker #picker></mat-date-range-picker>
                </mat-form-field>
              }
              <!-- Ng-select async -->
              @if (dato.tipo === 'ngselect-async') {
                <ng-select
                  [items]="(asyncData$![i] | async) ?? []"
                  [typeahead]="asyncInput$![i]"
                  [minTermLength]="3"
                  [placeholder]="dato.label"
                  [bindLabel]="dato.selectLabel!"
                  [bindValue]="dato.selectValue!"
                  [minTermLength]="3"
                  loadingText="Cargando..."
                  typeToSearchText="Buscar..."
                  notFoundText="No se encontraron resultados"
                  appendTo="body"
                  (change)="cambioFiltro()"
                  [(ngModel)]="dato.filter.value"
                  [ngModelOptions]="{ standalone: true }"
                ></ng-select>
              }
              <!-- Ng-select -->
              @if (dato.tipo === 'ngselect') {
                <ng-select
                  [items]="dato.elementos!"
                  [placeholder]="dato.label"
                  [bindLabel]="dato.selectLabel!"
                  [bindValue]="dato.selectValue!"
                  [searchFn]="dato.searchFn || null"
                  loadingText="Cargando..."
                  typeToSearchText="Buscar..."
                  notFoundText="No se encontraron resultados"
                  appendTo="body"
                  (change)="cambioFiltro()"
                  [(ngModel)]="dato.filter.value"
                  [ngModelOptions]="{ standalone: true }"
                  [multiple]="!!dato.multiple"
                  [closeOnSelect]="!dato.multiple"
                >
                  <!-- Sublabel opcional: línea chica y gris (ej. deveui). Si no
                       se define selectSubLabel, se muestra solo el label. -->
                  @if (dato.selectSubLabel) {
                    <ng-template ng-label-tmp let-item="item">
                      <span>{{ item[dato.selectLabel!] }}</span>
                      <small class="filtro-sublabel">{{
                        item[dato.selectSubLabel]
                      }}</small>
                    </ng-template>
                    <ng-template ng-option-tmp let-item="item">
                      <span>{{ item[dato.selectLabel!] }}</span>
                      <small class="filtro-sublabel">{{
                        item[dato.selectSubLabel]
                      }}</small>
                    </ng-template>
                  }
                </ng-select>
              }
              <!-- Ng-select Dispositivo (busca por deviceName/deveui, muestra FW/HW) -->
              @if (dato.tipo === 'ngselect-dispositivo') {
                <app-selector-dispositivo
                  [dispositivos]="dato.elementos || []"
                  [bindValue]="dato.selectValue || 'deveui'"
                  [placeholder]="dato.label"
                  (seleccion)="cambioFiltro()"
                  [(ngModel)]="dato.filter.value"
                  [ngModelOptions]="{ standalone: true }"
                ></app-selector-dispositivo>
              }
              <!-- RegExp -->
              @if (dato.tipo === 'regexp') {
                <mat-form-field>
                  <mat-label>{{ dato.label }}</mat-label>
                  <input
                    #inputSearch
                    matInput
                    type="search"
                    [placeholder]="dato.label"
                    [(ngModel)]="dato.filter.value"
                    [ngModelOptions]="{ standalone: true }"
                  />
                  @if (dato.filter.value) {
                    <button
                      matSuffix
                      mat-icon-button
                      type="button"
                      aria-label="Clear"
                      (click)="
                        dato.filter.value = undefined;
                        $event.stopPropagation();
                        cambioFiltro()
                      "
                    >
                      <mat-icon>close</mat-icon>
                    </button>
                  }
                </mat-form-field>
              }
              }
            }
          </form>
        </div>
      </mat-menu>
    </div>
  }
</div>
